const defaultFormatter = new Intl.ListFormat();

export const listFormatter = (list: string[]): string => {
  return defaultFormatter.format(list);
};
